export type Response<T, E = any> =
  | { ok: true; data: T }
  | { ok: false; error: E };

export const handleApiPayload = <T>(data: T) =>
  ({ ok: true, data } as Response<T>);
export const handleApiError = <T, E = any>(error: E) =>
  ({ ok: false, error: error } as Response<T>);
